import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useTierPopup from '@wix/da-shared-react/pkg/Tier/TierPopup/useTierPopup';
import { illustrationUrl } from '../../StudioBlankSlate';
import BasicBlankSlate from '../../_partials/BasicBlankSlate';

const SUBSCRIPTIONS_IMG_URL = illustrationUrl('studio-subscriptions-empty.png', 0);

const SubscriptionsBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  const openCreateTierPopup = useTierPopup();

  return (
    <BasicBlankSlate
      illustrationSrc={SUBSCRIPTIONS_IMG_URL}
      title={t('studio.blankSlate.subscriptions.title')}
      message={t('studio.blankSlate.subscriptions.message')}
      ctaLabel={t('studio.blankSlate.subscriptions.cta')}
      ctaOnClick={openCreateTierPopup}
    />
  );
};
SubscriptionsBlankSlate.displayName = 'SubscriptionsBlankSlate';

export default SubscriptionsBlankSlate;
